import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RouterService } from './routerService';

export interface PaidFeatureUpsellModalRow {
    label: string;
    free: string;
    subscriber: string;
}

export interface PaidFeatureUpsellModalConfig {
    title: string;
    primaryActionText: string;
    primaryActionRoute: string;
    rows: PaidFeatureUpsellModalRow[];
}

@Injectable()
export class PaidFeatureUpsellService {
    private readonly modalStateSource = new Subject<PaidFeatureUpsellModalConfig>();
    readonly modalState$ = this.modalStateSource.asObservable();

    private readonly defaultConfig: PaidFeatureUpsellModalConfig = {
        title: 'Subscribe for more...',
        primaryActionText: 'More Information',
        primaryActionRoute: '/account/subscribe',
        rows: [
            { label: 'Tender & Contract Award alerts', free: '✓', subscriber: '✓' },
            { label: 'Tender & Contract Award overviews', free: '✓', subscriber: '✓' },
            { label: 'Bespoke Tender & Contract Award summaries', free: '-', subscriber: '✓' },
            { label: 'PINs, Pipeline & Planning notice alerts', free: '-', subscriber: '✓' },
            { label: 'Full Buyer information for notices', free: '-', subscriber: '✓' },
            { label: 'Download Buyer documents in your account', free: '-', subscriber: '✓' },
            { label: 'Team access up to 10 users', free: '-', subscriber: '✓' },
            { label: 'Company monitoring', free: '-', subscriber: '✓' },
            { label: 'And so much more . . .', free: '-', subscriber: '✓' }
        ]
    };

    constructor(private readonly routerService: RouterService) {
    }

    open(config?: Partial<PaidFeatureUpsellModalConfig>) {
        const modalConfig: PaidFeatureUpsellModalConfig = {
            title: this.defaultConfig.title,
            primaryActionText: this.defaultConfig.primaryActionText,
            primaryActionRoute: this.defaultConfig.primaryActionRoute,
            rows: this.defaultConfig.rows
        };

        if (config) {
            if (config.title) {
                modalConfig.title = config.title;
            }

            if (config.primaryActionText) {
                modalConfig.primaryActionText = config.primaryActionText;
            }

            if (config.primaryActionRoute) {
                modalConfig.primaryActionRoute = config.primaryActionRoute;
            }

            if (config.rows) {
                modalConfig.rows = config.rows;
            }
        }

        this.modalStateSource.next(modalConfig);
    }

    openDefault() {
        this.open();
    }

    navigateToPrimaryAction(config?: PaidFeatureUpsellModalConfig) {
        const route = config && config.primaryActionRoute ? config.primaryActionRoute : this.defaultConfig.primaryActionRoute;
        this.routerService.router.navigate([route]);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/paid.feature.upsell.service.ts